<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_1"></a>Contents</h2>
<p class="toca"><a href="#/xhtml/foreword"><em>Author’s foreword</em></a></p>
<div class="lb-db">
<p class="toc1"><a href="#/xhtml/chapter01"><strong>GETTING STARTED</strong></a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec1">Range of pests and diseases</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec2">Prevention and control</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec3">Biological controls</a></p>
<p class="toc"><a href="#/xhtml/chapter01#sec4">Using pesticides and fungicides</a></p>
<p class="image"><img alt="Illustration" src="images/f0001-01.jpg"/></p>
</div>
<div class="org-dorg">
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><strong>ORNAMENTAL PLANTS</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec5" title="Link target outside of Sample">Border flowers and bedding plants</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec6" title="Link target outside of Sample">Ornamental trees and shrubs</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec7" title="Link target outside of Sample">Plants in containers</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec8" title="Link target outside of Sample">Roses</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec9" title="Link target outside of Sample">Water-garden plants</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec10" title="Link target outside of Sample">Rock-garden plants</span></p>
<p class="toc"><span href="#/xhtml/chapter02#sec11" title="Link target outside of Sample">Lawns</span></p>
</div>
<div class="gr-dgr">
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><strong>HERBS, FRUITS AND VEGETABLES</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec12" title="Link target outside of Sample">Culinary herbs</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec13" title="Link target outside of Sample">Soft fruits</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec14" title="Link target outside of Sample">Tree fruits</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec15" title="Link target outside of Sample">Prevention and control for fruits</span></p>
<p class="toc"><span href="#/xhtml/chapter03#sec16" title="Link target outside of Sample">Vegetables</span></p>
<p class="image"><img alt="Illustration" src="images/f0001-02.jpg"/></p>
</div>
<div class="vio-dvio">
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><strong>INDOOR PLANTS</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec17" title="Link target outside of Sample">Plants in homes and greenhouses</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec18" title="Link target outside of Sample">Orchids</span></p>
<p class="toc"><span href="#/xhtml/chapter04#sec19" title="Link target outside of Sample">Cacti and other succulents</span></p>
<p class="image"><img alt="Illustration" src="images/f0001-03.jpg"/></p>
</div>
<p class="toca"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><em>Checklist for “green” solutions</em></span></p>
<p class="toca"><span href="#/xhtml/glossary" title="Link target outside of Sample"><em>Glossary</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5bd8f64f